import React from 'react';
import Joyride, { STATUS } from 'react-joyride';
import './style.scss';

const Tutorial = ({ steps, run, onFinish }) => {

    const handleJoyrideCallback = (data) => {
        const { status } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (onFinish) {
                onFinish();
            }
        }
    };

    return (
        <Joyride
            steps={steps}
            run={run}
            continuous={true}
            showSkipButton={true}
            showProgress={false} // Disable default progress to keep it minimal
            callback={handleJoyrideCallback}
            disableOverlayClose={true} // Force user to interact with buttons
            spotlightClicks={true}
            spotlightPadding={4} // 4px micro adjustment
            styles={{
                options: {
                    zIndex: 10000,
                    primaryColor: '#2E7CF6', // Info color
                    overlayColor: 'rgba(0, 0, 0, 0.65)',
                    spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
                    arrowColor: 'var(--color-bg-primary)', // Dynamic Theme Color
                },
                spotlight: {
                    borderRadius: '8px', // Match system radius
                }
            }}
            floaterProps={{
                disableAnimation: true, // cleaner
            }}
            scrollOffset={100}
            scrollToFirstStep={true}
            tooltipComponent={Tooltip}
        />
    );
};

const Tooltip = ({
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    isLastStep
}) => {
    return (
        <div className="tutorial-tooltip" {...tooltipProps}>
            {step.title && <h4>{step.title}</h4>}
            <div className="tutorial-body">{step.content}</div>

            <div className="tutorial-footer">
                <button className="btn-skip" {...closeProps}>
                    {isLastStep ? 'Fechar' : 'Pular'}
                </button>

                <div className="tutorial-actions">
                    {index > 0 && (
                        <button className="btn-back" {...backProps}>
                            Voltar
                        </button>
                    )}
                    <button className={isLastStep ? "btn-finish" : "btn-next"} {...primaryProps}>
                        {isLastStep ? 'Concluir' : 'Próximo'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Tutorial;
